<template>
<div >
  <b-field label="Email address to notify" :type="type" :message="message">
    <b-input type="text" v-model="email" @input="validate"></b-input>
   </b-field>
   <div class="has-text-right">
    <b-button  type="is-primary" @click="save">SAVE</b-button>
    <b-button class="ml-2" @click="$emit('cancel','email')">CANCEL</b-button>
  </div>
 </div>
</template>
<script>
    export default {
      name: "Email",
      components: {},
      data() {
        return {
         message : null,
         email : null,
         type : null,
         reg : /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
        }
      },
     
      methods:{
        validate() {
         let isValid=false;
          if(this.reg.test(this.email)){ 
            this.message = null;
            this.type = null
            isValid = true;
          } else {
            this.message = 'Please enter valid email.';
            this.type = 'is-danger'
            isValid = false;
          }
          return isValid
        }, 
        save() {
         let isValid = this.validate();
            if(isValid){
               this.$emit('saveEmail',this.email);
            }
        }
      },
    }
  </script>

<style scoped>
  .minmaxmobile{
    width: 460px;
    max-width: 100%;
  }
</style>
